<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    title="小程序"
    :onFetchData="onFetchData"
    namespace="wechat_third_party_platform/"
    resource="wtpp_applications"
    :batchActions="batchActions"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { WTPP_APPLICATION_PRINCIPAL_TYPE, TAG_TYPE, SUBMITION_STATE } from '@/constants';
import _ from 'lodash';
import { abilityService } from 'beans-admin-plugin';

@Component
export default class WTPPApplication extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}
  templates = []
  commitFormValues = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'appid_cont',
        label: 'AppID',
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'principal_name_cont',
        label: '实体名称',
        renderCell: {
          component: 'input'
        }
      },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'appid',
        label: 'AppID',
        width: 150,
      },
      {
        prop: 'nick_name',
        label: '昵称',
        width: 120,
      },
      {
        prop: 'head_img',
        label: '头像',
        width: 80,
        renderCell: {
          component: 'storageAttachment',
          props: {
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            objectFit: 'cover'
          }
        }
      },
      {
        prop: 'user_name',
        label: '原始ID',
      },
      {
        prop: 'principal_name',
        label: '主体名称',
      },
      {
        prop: 'principal_type',
        label: '主体类型',
        renderCell: (h, { props: { value } }) => {
          return <span>{ WTPP_APPLICATION_PRINCIPAL_TYPE[value] }</span>;
        }
      },
      {
        prop: 'trial_submition.user_version',
        label: '体验版本',
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <span>{value}</span>
          } else {
            return <span>无</span>
          }
        }
      },
      type === 'show' && {
        prop: 'trial_submition.user_desc',
        label: '体验版本描述'
      },
      type === 'show' && {
        prop: 'trial_submition.trial_version_qrcode',
        label: '体验版二维码',
        renderCell: {
          component: 'storageAttachment',
        }
      },
      {
        prop: 'online_submition.user_version',
        label: '线上版本',
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <span>{value}</span>
          } else {
            return <span>无</span>
          }

        }
      },
      type === 'show' && {
        prop: 'online_submition.user_desc',
        label: '线上版本描述'
      },
      {
        prop: 'qrcode_url',
        label: '线上版小程序码',
        width: 200,
        renderCell: {
          component: 'storageAttachment',
        }
      },
      {
        prop: 'audit_submition.user_version',
        label: '审核版本',
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <span>{value}</span>
          } else {
            return <span>无</span>
          }
        }
      },
      type === 'show' && {
        prop: 'audit_submition.user_desc',
        label: '审核版本描述'
      },
      {
        prop: 'audit_submition.state',
        label: '审核状态',
        width: 120,
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <el-tag type={TAG_TYPE[value]}>{ SUBMITION_STATE[value] }</el-tag>;
          } else {
            return <span>无审核版本</span>
          }
        }
      },
      type === 'show' && {
        prop: 'audit_submition.reason',
        label: '原因',
        renderCell: 'html'
      },
      {
        prop: 'created_at',
        label: '创建时间',
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      },
      {
        prop: 'updated_at',
        label: '更新时间',
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      }
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [];
  }

  batchActions({ selection }) {
    const handleSetWeappSupportVersion = async (value, applicationIds) => {
      const body = { ...value, application_ids: applicationIds };
      await this.$autoLoading(this.$request.post('/wechat_third_party_platform/applications/set_weapp_support_version', body));
      this.$message.success('最低基础库版本设置成功');
    }

    return [
      selection.length === 0 ? {
        functional: true,
        render() {
          if (abilityService.can('wtpp_applications.set_weapp_support_version')) {
            return <el-button type="primary" size="mini" disabled>设置最低基础库版本</el-button>;
          } else {
            return null;
          }
        }
      } : {
        component: 'dialogFormButton',
        props: {
          label: '设置最低基础库版本',
          disabled: selection.length === 0,
          columns: [{
            prop: 'weapp_support_version',
            label: '最低基础库版本',
            renderCell: {
              component: 'input',
              required: true,
              hint: 'eg: 2.11.0'
            }
          }],
          can: 'wtpp_applications.set_weapp_support_version',
          submitHandler: (value) => { handleSetWeappSupportVersion(value, _.map(selection, 'id')); }
        }
      },
    ].filter(Boolean);
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { reload }) {
    const env = process.env.VUE_APP_ENV;
    const commitColumns = [
      {
        prop: 'template_id',
        label: '代码模板',
        renderCell: {
          component: 'select',
          required: true,
          props: {
            xRemotePreload: async() => {
              const collection = await this.$request.get('/wechat_third_party_platform/templates?per_page=50');
              this.templates = collection.data
              return collection.data.map(({ template_id, user_version }) => ({ value: template_id, label: user_version }))
            },
          },
          on: {
            change: value => {
              if (!value) {
                return
              }

              const template = this.templates.find(template => template.template_id === value)

              this.commitFormValues.user_version = template.user_version
              this.commitFormValues.user_desc = template.user_desc
            }
          }
        }
      },
      {
        prop: 'user_version',
        label: '代码版本号',
        renderCell: {
          required: true,
          component: 'input',
        }
      },
      {
        prop: 'user_desc',
        label: '代码描述',
        renderCell: {
          required: true,
          component: 'input',
        }
      }
    ]

    let canSubmitAudit = false
    let canRelease = false
    let canMockSubmitAudit = false
    let canMockAuditSuccess = false
    let canMockAuditFail = false
    let canMockAuditDelay = false
    let canMockRelease = false

    if (row.trial_submition) {
      if (env === 'development') {
        canMockSubmitAudit = !row.audit_submition || (row.audit_submition.state !== 'pending' && row.audit_submition.state !== 'delay')
      } else {
        canSubmitAudit = !row.audit_submition || (row.audit_submition.state !== 'pending' && row.audit_submition.state !== 'delay')
      }
    }

    if (row.audit_submition) {
      if (env === 'development') {
        canMockAuditSuccess = (row.audit_submition.state === 'pending' || row.audit_submition.state === 'delay')
        canMockAuditFail = (row.audit_submition.state === 'pending' || row.audit_submition.state === 'delay')
        canMockAuditDelay = row.audit_submition.state === 'pending'
        canMockRelease = row.audit_submition.state === 'success'
      } else {
        canRelease = row.audit_submition.state === 'success'
      }
    }

   const handleCommit = async (value) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${row.id}/commit`, { ...value }));
      this.$message.success('上传成功');
      reload();
    }

    const handleSubmitAudit = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/submit_audit`));
      this.$message.success('提交成功');
      reload();
    }

    const handleMockSubmitAudit = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/mock_submit_audit`));
      this.$message.success('模拟提交成功');
      reload();
    }

    const handleMockAuditSuccess = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/mock_audit_success`));
      this.$message.success('模拟审核通过成功');
      reload();
    }

    const handleMockAuditFail = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/mock_audit_fail`));
      this.$message.success('模拟审核不通过成功');
      reload();
    }

    const handleMockAuditDelay = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/mock_audit_delay`));
      this.$message.success('模拟审核延后成功');
      reload();
    }

    const handleRelease = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/release`));
      this.$message.success('发布成功');
      reload();
    }

    const handleMockRelease = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/mock_release`));
      this.$message.success('模拟发布成功');
      reload();
    }

    const handleSynchBaseData = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/aynch_base_data`));
      this.$message.success('操作成功，同步存在延迟，请过段时间再刷新查看');
    }

    const handleGetWeappSupportVersion = async () => {
      const data = await this.$autoLoading(this.$request.get(`/wechat_third_party_platform/applications/${row.id}/get_weapp_support_version`));
      this.$message({
        showClose: true,
        message: `${row.appid} 的最低基础库版本为${data.now_version}`,
        duration: 0
      });
    }

    return [
      (
        () => <bean-dialog-form
          columns={commitColumns}
          value={this.commitFormValues}
          onChange={ value => { this.commitFormValues = value } }
          submitHandler={ value => handleCommit(value) }
        >
          <el-button type='primary'>上传代码</el-button>
        </bean-dialog-form>
      ),
      canSubmitAudit && {
        component: 'confirmButton',
        props: {
          label: '提交审核',
          type: 'primary',
          can: 'wtpp_applications.submit_audit'
        },
        on: {
          confirm: () => handleSubmitAudit(row.id)
        }
      },
      canMockSubmitAudit && {
        component: 'confirmButton',
        props: {
          label: '模拟提交审核',
          type: 'primary',
          can: 'wtpp_applications.submit_audit'
        },
        on: {
          confirm: () => handleMockSubmitAudit(row.id)
        }
      },
      canMockAuditSuccess && {
        component: 'confirmButton',
        props: {
          label: '模拟审核通过',
          type: 'primary',
          can: 'wtpp_applications.submit_audit'
        },
        on: {
          confirm: () => handleMockAuditSuccess(row.id)
        }
      },
      canMockAuditFail && {
        component: 'confirmButton',
        props: {
          label: '模拟审核不通过',
          type: 'primary',
          can: 'wtpp_applications.submit_audit'
        },
        on: {
          confirm: () => handleMockAuditFail(row.id)
        }
      },
      canMockAuditDelay && {
        component: 'confirmButton',
        props: {
          label: '模拟审核延后',
          type: 'primary',
          can: 'wtpp_applications.submit_audit'
        },
        on: {
          confirm: () => handleMockAuditDelay(row.id)
        }
      },
      canRelease && {
        component: 'confirmButton',
        props: {
          label: '发布',
          type: 'primary',
          can: 'wtpp_applications.release'
        },
        on: {
          confirm: () => handleRelease(row.id)
        }
      },
      canMockRelease && {
        component: 'confirmButton',
        props: {
          label: '模拟发布',
          type: 'primary',
          can: 'wtpp_applications.release'
        },
        on: {
          confirm: () => handleMockRelease(row.id)
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: '同步基本信息',
          type: 'primary',
          can: 'wtpp_applications.update'
        },
        on: {
          confirm: () => handleSynchBaseData(row.id)
        }
      },
      abilityService.can('wtpp_applications.read') && {
        functional: true,
        render() {
          return <el-button type="primary" size="mini" onClick={handleGetWeappSupportVersion}>查看最低基础库版本</el-button>;
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/wechat_third_party_platform/applications', { params: { ...this.$route.query } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show') {
      const data = await this.$request.get(`/wechat_third_party_platform/applications/${this.$route.params.id}`);
      return { data };
    }
  }
}

export const route = [
  {
    path: '/wtpp_applications',
    name: 'wtpp_applications.index',
    component: WTPPApplication,
    props: {
      type: 'index',
    }
  },
  {
    path: '/wtpp_applications/new',
    name: 'wtpp_applications.new',
    component: WTPPApplication,
    props: {
      type: 'new',
    }
  },
  {
    path: '/wtpp_applications/:id',
    name: 'wtpp_applications.show',
    component: WTPPApplication,
    props: {
      type: 'show',
    }
  }
]
</script>
